// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface PencilWriteIconSignature {
  Element: SVGSVGElement;
}

export const PencilWriteIcon: TOC<PencilWriteIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M17.586 2.58599C18.367 1.80499 19.633 1.80499 20.414 2.58599C21.195 3.36699 21.195 4.63299 20.414 5.41399L14.051 11.779L11.222 8.94999L17.586 2.58599ZM4 22C2.897 22 2 21.103 2 20V5.99999C2 4.89799 2.897 3.99999 4 3.99999H11V5.99999H4V20H18V11H20V20C20 21.103 19.103 22 18 22H4ZM9.101 13.899L9.808 10.365L12.636 13.192L9.101 13.899Z"/>
</svg>
</template>;